import { clearError } from '.'

export const resetError = () => (dispatch: any) => dispatch(clearError())
